type KtmProps = {
  className?: string;
};

export default function Ktm({ className }: KtmProps) {
  return (
    <svg
      width="104"
      height="32"
      viewBox="0 0 104 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <title>KTM</title>
      <g clipPath="url(#clip0_18794_229820)">
        <path
          d="M0.500977 32.0002L10.9709 7.36806L25.2261 7.38605L21.2014 16.9357L33.17 7.36806H42.9267L31.2593 17.095L38.0084 25.9456L46.5652 4.47695L26.2587 4.47952L27.8861 0.000244141H82.8521L81.5903 4.47181H61.0882L55.3279 21.1554L69.0964 7.36549H81.7268L79.708 16.7635L90.3273 7.36549H103.501L98.06 31.9977H84.9636L86.3283 23.1727L76.3167 31.9977H64.1653L65.7592 23.0828L56.1699 31.9977L25.1643 32.0002L18.508 23.1727L14.8875 32.0002H0.500977Z"
          fill="#121212"
        />
      </g>
      <defs>
        <clipPath id="clip0_18794_229820">
          <rect
            width="103"
            height="32"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
